// extracted by mini-css-extract-plugin
export default {"save-and-exit-button":"Header-module__save-and-exit-button__TAXHS"};